<template>
    <DCard padding>
        <DCol>
            <DRow
                class="mb-3"
                align-vertical="end"
            >
                <DCol sm="2">
                    <DInput
                        id="invoice_id"
                        v-model="filterParams.invoice_id"
                        :label="__('tools.debt_loss_invoices.filters.invoice_id')"
                        class="mb-0"
                        type="text"
                        @keydown.enter.exact.prevent="changePage(1)"
                    />
                </DCol>
                <DCol sm="2">
                    <DInput
                        id="customer_id"
                        v-model="filterParams.customer_id"
                        :label="__('tools.debt_loss_invoices.filters.customer_id')"
                        class="mb-0"
                        type="text"
                        @keydown.enter.exact.prevent="changePage(1)"
                    />
                </DCol>
                <DCol sm="2">
                    <DDateFormatInput
                        id="date-from"
                        v-model="filterParams.from_date"
                        format="YYYY-MM-DD"
                        type="date"
                        :have-class="'mb-0'"
                        :label="__('tools.debt_loss_invoices.filters.debtloss_from_date')"
                        add-input-classes="bg-light"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage(1)"
                    />
                </DCol>
                <DCol sm="2">
                    <DDateFormatInput
                        id="date-to"
                        v-model="filterParams.to_date"
                        format="YYYY-MM-DD"
                        type="date"
                        :have-class="'mb-0'"
                        :label="__('tools.debt_loss_invoices.filters.debtloss_to_date')"
                        add-input-classes="bg-light"
                        class="mb-0"
                        @keydown.enter.exact.prevent="changePage(1)"
                    />
                </DCol>
                <DCol
                    sm="3"
                    class="d-flex gap-2"
                >
                    <DButton
                        id="filter-apply"
                        :label="__('tools.invoices.filters.filter')"
                        @click="changePage(1)"
                    />
                    <DButton
                        id="filter-reset"
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
        </DCol>
        <DebtLossInvoicesTable
            :debt-loss-invoices="debtLossInvoices.data"
        />
        <DPagination
            v-if="debtLossInvoices.last_page > 1"
            class="pb-2"
            :active-page="debtLossInvoices.current_page"
            :pages="debtLossInvoices.last_page"
            align="center"
            @update:activePage="changePage"
        />
    </DCard>
</template>

<script>
import DebtLossInvoicesTable from '~@/Components/Tools/Invoices/DebtLossInvoicesTable.vue'

export default {
    name: 'DebtLossInvoices',
    components: { DebtLossInvoicesTable },
    props: {
        debtLossInvoices: {
            type: Object,
            default: () => {
                return {}
            }
        },
        filters: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            filterParams: {
                invoice_id: this.filters.invoice_id,
                customer_id: this.filters.customer_id,
                from_date: this.filters.from_date,
                to_date: this.filters.to_date
            }
        }
    },
    methods: {
        changePage (page) {
            const queryParameters = Object.fromEntries(Object.entries(this.filterParams).filter(([_, v]) => v))

            if (page !== 1) {
                queryParameters.page = page
            }

            this.$inertia.get(this.$route('tools.debtloss-invoices', {
                save_filters: true
            }), queryParameters)
        },
        resetFilters () {
            this.$inertia.get(this.$route('tools.debtloss-invoices', {
                default_filters: true,
                save_filters: true
            }))
        }
    }
}
</script>

<style scoped>

</style>
